import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

type CircleQuestionIconProps = Icon & {
    circleColor: string,
    questionColor: string
}

export const CircleQuestionIcon = (props: CircleQuestionIconProps) => {
    const {
        questionColor = colors.flamingOrange,
        circleColor = colors.bbqBrown,
        size = 24,
        ...otherProps
    } = props

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            {...otherProps}>
            <path
                d="M12.2038 2.3999C7.2388 2.3999 2.94723 6.30104 3.00049 11.308C3.02332 13.3776 3.87174 15.5547 5.29466 17.2596C5.37836 17.3594 5.15008 21.3296 5.48869 21.5869C5.75121 21.7866 8.26604 19.621 8.38018 19.6747C9.4721 20.1854 10.6934 20.4542 11.9983 20.3927C16.9595 20.3927 21 16.3188 21 11.308C21 6.2972 17.165 2.3999 12.2038 2.3999ZM12.006 18.2272C10.5792 18.2272 9.49492 17.9699 8.48671 17.3939C8.25082 17.2596 7.08281 19.0066 6.86976 18.8453C6.6567 18.6841 7.16271 16.434 6.97248 16.2497C5.70555 15.0095 5.05877 13.3584 4.83811 11.4002C4.40819 7.61038 8.22419 4.39271 12.006 4.39271C15.8334 4.12009 19.0026 6.65813 18.8618 11.3119C18.7439 15.1247 15.7877 18.231 12.006 18.231V18.2272Z"
                fill={circleColor}
            />
            <path
                d="M10.64 11.8416C10.64 10.8855 11.2906 10.467 11.9526 10.0984C12.2912 9.91407 12.5499 9.71825 12.5499 9.43027C12.5499 9.27284 12.432 9.12693 12.1999 9.12693C11.9678 9.12693 11.7966 9.27284 11.458 9.8488C11.1841 10.3211 10.7846 10.5169 10.3167 10.5169C9.60139 10.5169 8.92798 10.0177 8.92798 9.08853C8.92798 7.63329 10.408 6.73096 12.1505 6.73096C13.893 6.73096 15.3045 7.67552 15.3045 9.16917C15.3045 10.3096 14.8745 10.8202 14.3419 11.2004C13.9272 11.5037 13.6 11.7763 13.4973 12.1718C13.3413 12.7862 12.744 13.1279 12.082 13.1279C11.3287 13.1279 10.64 12.7209 10.64 11.8416ZM10.4726 14.921C10.4726 14.1877 11.0433 13.5695 12.0439 13.5695C13.0445 13.5695 13.6152 14.1838 13.6152 14.921C13.6152 15.6583 13.0445 16.2841 12.0439 16.2841C11.0433 16.2841 10.4726 15.6698 10.4726 14.921Z"
                fill={questionColor}
            />
        </svg>
    )
}
